import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { createOrderV2Client } from '../api/client';
import { orderV2QueryKeys } from '../api/queryKeys';
import { ShiftSupervisor } from '../api/types';

const useShiftSupervisors = (billingAccountId: number | null) => {
  const enabled = billingAccountId != null;
  const queryClient = useQueryClient();
  const query = useQuery<ShiftSupervisor[]>({
    queryKey: enabled
      ? orderV2QueryKeys.shiftSupervisors(billingAccountId)
      : ['orders_v2', 'shift_supervisors', 'disabled'],
    queryFn: () =>
      createOrderV2Client
        .listShiftSupervisors(billingAccountId as number)
        .then((result) => result || []),
    enabled,
  });

  const refreshShiftSupervisors = useCallback(async () => {
    if (!enabled) return;
    await queryClient.invalidateQueries({
      queryKey: orderV2QueryKeys.shiftSupervisors(billingAccountId),
    });
  }, [enabled, billingAccountId, queryClient]);

  return {
    shiftSupervisors: query.data ?? [],
    refreshShiftSupervisors,
  };
};

export default useShiftSupervisors;
